import React from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import {Helmet} from 'react-helmet';
import {centsToCurrencyString} from '../../utils/numbers';
import Button from "../Button";
import UserCinemaNav from '../UserCinemaNav';
import {candybarItemRemove} from '../../actions/creators/checkout/candybar';
import {getCheckoutPrevStep, getWalletAddCardInfo, getWalletStep, isCheckoutPayButtonDisabled, isCheckoutPayButtonVisible, isPaymentSuggestionNeeded, shouldCheckoutRenderWallet} from '../../reducers';
import CheckoutSidebarLoyaltyBlock from "./Sidebar/CheckoutSidebarLoyaltyBlock";
import {getCheckoutJsonLdObject} from '../../utils/jsonLd';
import WalletCard from './WalletCard';
import {t1ExistingCardPayment, t1NewCardPayment} from '../../actions/creators/checkout/payment';
import { getBrand } from '../../utils/creditCards';
import { AnalyticsBillboards } from '../../utils/analytics';
import StepIndicator from './StepIndicator';
import CheckoutSidebarItemsBlock from './Sidebar/CheckoutSidebarItemsBlock';
import CheckoutSidebarMovieBlock from './Sidebar/CheckoutSidebarMovieBlock';

const orgId = '1snn5n9w';
const merchantId = 't1_cinemex';

const PlusFeeLegend = styled.span`
  display: inline-block;
  font-size: 0.75em;
  line-height: 1.2;
  opacity: 0.5;
`;

const Gradient = styled.div`
  height: 4rem;
  background: linear-gradient(0deg, rgba(255,255,255,1) 25%, rgba(255,255,255,0) 100%);

  body.theme-market & {
    background: linear-gradient(0deg, rgba(0,0,0,1) 25%, rgba(0,0,0,0) 100%);
  }

  body.theme-platinum & {
    background: linear-gradient(0deg, rgba(115, 16, 19, 1) 25%, rgba(115, 16, 18, 0) 100%);
  }
`;

const NextButtonContainer = styled.div`
  background: var(--page-bg);
  border-top: 1px solid var(--text-primary);

  body.theme-platinum & {
    border-top: none;
  }
`;

let fixedButton;
let floatingButton;
function scrollHandler() {
  // if (!fixedButton) {
  //   return;
  // }

  // var visible = isElementInViewport(fixedButton);

  // if (visible) {
  //   floatingButton.style.display = 'none';
  // } else if (window.innerWidth >= breakpoints.phone) {
  //   floatingButton.style.display = 'block';
  // }
}

class CheckoutSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.paymentSubmit = this.paymentSubmit.bind(this);
  }

  componentDidMount() {
    window.addEventListener('DOMContentLoaded', scrollHandler, false);
    window.addEventListener('load', scrollHandler, false);
    window.addEventListener('scroll', scrollHandler, false);
    window.addEventListener('resize', scrollHandler, false);
  }

  componentWillUnmount() {
    window.removeEventListener('DOMContentLoaded', scrollHandler, false);
    window.removeEventListener('load', scrollHandler, false);
    window.removeEventListener('scroll', scrollHandler, false);
    window.removeEventListener('resize', scrollHandler, false);
  }

  componentDidUpdate() {
    fixedButton = document.getElementById('checkout-static-bt');
    floatingButton = document.getElementById('checkout-floating-bt');
    scrollHandler();
  }

  renderBookingFee() {
    const {bookingFee} = this.props;

    if (!bookingFee) {
      return '';
    }

    return (
        <div className="row fade-in">
          <div className="col-4">
            <h3 className="h6 small text-uppercase mt-1 mb-0">Costo por servicio</h3>
          </div>
          <div className="col-8">
            <p className="mb-0">{centsToCurrencyString(bookingFee)}</p>
          </div>
        </div>
    );
  }

  renderTotal() {
    const { grandTotalPaymentString } = this.props;

    if (!grandTotalPaymentString) {
      return '';
    }

    return (
        <React.Fragment>
          <hr className="my-4"/>
          <div className="row align-items-center fade-in">
            <div className="col-4">
              <h3 className="h6 small text-uppercase mb-0">Total a pagar</h3>
            </div>
            <div className="col-8">
              <p className="mb-0">
                <span className="lead text-primary">{grandTotalPaymentString}</span>
                {this.props.tickets && this.props.tickets.length ? this.props.bookingFee === null && (
                    <PlusFeeLegend className="ml-1"> + costo por servicio</PlusFeeLegend>
                ) : null}
              </p>
            </div>
          </div>
          {this.props.tickets && this.props.tickets.length ? (
            <div className="mt-2">
              <PlusFeeLegend>
                Esta transacción tendrá un costo por servicio según los boletos seleccionados.
                {this.props.bookingFee === null && (
                  <span> El valor se mostrará en el siguiente paso.</span>
                )}
              </PlusFeeLegend>
            </div>
          ) : null}
        </React.Fragment>
    );
  }

  getNextButton() {
    const nextStep = this.props.nextStep;
    const onClick = this.props.nextStepAction;
    const text = this.props.nextButtonText;
    
    switch (nextStep) {
      case 'seats':
      case 'candybar':
      case 'payment-suggestions':
      case 'payment':
        return <Button primary large block onClick={onClick}>{text}</Button>;
      case 'confirmation':
        return this.props.isPayButtonVisible ? <Button disabled={this.props.isPayButtonDisabled} primary large block onClick={this.paymentSubmit}>Finalizar</Button> : '';
      default:
        return '';
    }
  }

  paymentSubmit() {
    if (this.props.walletStep === 2) { // @todo use vars instead of harcoded numbers
      this.props.tokenCardPaymentSubmit();
    } else {
      this.props.newCardPaymentSubmit();
    }
  }

  render() {
    const {cinema, movie, session} = this.props;

    if (this.props.renderWalletSidebar) {
      return this.renderWalletSidebar();
    }

    return (
        <React.Fragment>
          <Helmet>
            <title>Checkout - Cinemex</title>
            <script type="application/ld+json">
              {movie && JSON.stringify(getCheckoutJsonLdObject(session, movie, cinema))}
            </script>
            <link href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@400&amp;display=swap" rel="stylesheet"/>
            {this.props.localSessionId && <script type="text/javascript" src={`https://h.online-metrix.net/fp/tags.js?org_id=${orgId}&session_id=${merchantId}${this.props.localSessionId}`}></script>}
          </Helmet>

          <UserCinemaNav cinemaSelector={false} showInMobile={false}/>

          <div className="container d-none d-md-block">
            <StepIndicator sidebar/>
          </div>

          <CheckoutSidebarLoyaltyBlock />

          <div className="d-none d-md-block">

            <div className="container mb-4">

              {this.props.movie && <CheckoutSidebarMovieBlock movie={this.props.movie} cinema={this.props.cinema} session={this.props.session}/>}
              <CheckoutSidebarItemsBlock candybarOrder={this.props.candybarOrder} candybarCatalog={this.props.candybarCatalog} seatsLabels={this.props.seatsLabels} ticketsString={this.props.ticketsString}/>
              {this.renderBookingFee()}
              {this.renderTotal()}

            </div>

            {(this.props.grandTotal > 0 || this.props.ticketsSum > 0) && (
              <React.Fragment>
              <NextButtonContainer id="checkout-static-bt" className="container py-3 py-md-5 _d-none md-d-block w-100">
                {this.getNextButton()}
              </NextButtonContainer>
              <div id="checkout-floating-bt" style={{position:'fixed',width:'35%',bottom:0,display:'none'}}>
                <Gradient></Gradient>
                <NextButtonContainer className="container py-3 p-md-5">
                  {this.getNextButton()}
                </NextButtonContainer>
              </div>
              </React.Fragment>
            )}
            
          </div>

        </React.Fragment>
    );
  }

  renderWalletSidebar() {
    const info = this.props.walletAddCardInfo.params;
    const {focused} = this.props.walletAddCardInfo;

    return <React.Fragment>
        <div className="px-5 py-5 mt-5"><WalletCard
            brand={getBrand(info.cc || '')}
            number={info.cc ? info.cc.replace(/[ ]/g, '') : ''}
            csc={info.csc}
            cardHolderName={info.name}
            expMonth={info['expire-month']}
            expYear={info['expire-year'] || ''}
            focused={focused}
        /></div>
        <NextButtonContainer className="container py-3 p-md-5 sm-fixed-bottom w-100 border-top">
            {this.getNextButton()}
        </NextButtonContainer>
      </React.Fragment>;
  }
}

const mapStateToProps = (state, props) => {
  const {movie, cinema} = props;
  let candybarItems = 0;
  const session = state.checkoutData.data;
  const candybarOptions = state.entities.candybarOptions;
  const localSessionId = state.checkoutData.t1.sessionId;
  const walletStep = getWalletStep(state);
  const skipPaymentOptions = !isPaymentSuggestionNeeded(state);

  if (props.candybarOrder) {
    candybarItems = Object.keys(props.candybarOrder).length;
  }

  const renderWallet = shouldCheckoutRenderWallet(state);
  const renderWalletSidebar = renderWallet && walletStep > 1

  return {
    candybarOptions,
    candybarItems,
    candybarEditing: !!state.checkoutData.candybar.selectedItem,
    cinema,
    isPayButtonVisible: isCheckoutPayButtonVisible(state),
    isPayButtonDisabled: isCheckoutPayButtonDisabled(state),
    localSessionId,
    movie,
    prevStep: getCheckoutPrevStep(state),
    points: state.checkoutData.points,
    renderWallet,
    renderWalletSidebar,
    session,
    skipPaymentOptions,
    walletAddCardInfo: getWalletAddCardInfo(state),
    walletStep,
  };
};

const mapDispatchToProps = dispatch => ({
  newCardPaymentSubmit: () => dispatch(t1NewCardPayment()),
  tokenCardPaymentSubmit: () => dispatch(t1ExistingCardPayment()),
  candybarItemRemove: (itemId, unitId) => dispatch(candybarItemRemove(itemId, unitId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutSidebar);